import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { forkJoin, map, Observable } from 'rxjs';

import { APP_VERSION } from '../build-info';

const MODULES = ['common', 'layout', 'auth', 'profile', 'partners', 'customers', 'team', 'validation'];

@Injectable()
export class ModuleTranslationLoader extends TranslateLoader {
  private http = inject(HttpClient);

  public getTranslation(lang: string): Observable<TranslationObject> {
    // Cache-bust per build: embedded webviews (CSP desktop app) can't hard-reload,
    // so stale translation files would otherwise persist after a deploy.
    const version = `?v=${APP_VERSION}`;

    const appTranslations$ = MODULES.map((name) =>
      this.http.get<TranslationObject>(`./assets/i18n/${name}/${name}-${lang}.json${version}`)
    );
    const libsTranslations$ = this.http.get<TranslationObject>(`./assets/i18n/libs/libs-${lang}.json${version}`);

    return forkJoin([...appTranslations$, libsTranslations$]).pipe(
      map((translations) => Object.assign({}, ...translations))
    );
  }
}

export function customLoaderFactory(): ModuleTranslationLoader {
  return new ModuleTranslationLoader();
}
